export const EXPANDED_STRIPE_WIDTH = "100vw";
export const RETRACTED_STRIPE_WIDTH = "0vw";
export const EXPAND_STRIPE_DURATION = 0.3;
export const RETRACK_STRIPE_DURATION = 0.3;
